import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6]">
        <Loader2 className="animate-spin text-[#1C4532]" size={28}/>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace/>;

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    const home = user.role === "admin" ? "/admin" : user.role === "worker" ? "/worker" : "/dashboard";
    return <Navigate to={home} replace/>;
  }

  return children;
}
